import { render, staticRenderFns } from "./DigitalPromoSidebar.vue?vue&type=template&id=5a633e9e&"
import script from "./DigitalPromoSidebar.vue?vue&type=script&lang=js&"
export * from "./DigitalPromoSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a633e9e')) {
      api.createRecord('5a633e9e', component.options)
    } else {
      api.reload('5a633e9e', component.options)
    }
    module.hot.accept("./DigitalPromoSidebar.vue?vue&type=template&id=5a633e9e&", function () {
      api.rerender('5a633e9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/digital-promo/DigitalPromoSidebar.vue"
export default component.exports